import { Component, EventEmitter, Input, Output } from "@angular/core";

import { SkeletonModule } from "primeng/skeleton";

import { fadeInOutAnimation, rotate, verticalSlideToggle } from "@shared/animations";

@Component({
  selector: "app-accordion",
  standalone: true,
  imports: [SkeletonModule],
  templateUrl: "./accordion.component.html",
  styleUrl: "./accordion.component.scss",
  animations: [rotate, verticalSlideToggle, fadeInOutAnimation],
})
export class AccordionComponent {
  @Input() title: string = "Placeholder";
  @Input() visible: boolean = false;
  @Output() visibleChange = new EventEmitter<boolean>();

  toggleAccordion() {
    this.visible = !this.visible;
    this.visibleChange.emit(this.visible);
  }
}
